import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layout
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Pages
import Home from './pages/Home';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import FindTeachers from './pages/FindTeachers';
import TeacherProfile from './pages/TeacherProfile';
import MyLessons from './pages/MyLessons';
import VideoRoom from './pages/VideoRoom';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import BecomeTeacher from './pages/BecomeTeacher';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Teacher Only Route
const TeacherRoute = ({ children }) => {
  const { currentUser, userProfile } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  if (userProfile?.role !== 'teacher') {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="app">
      <Navbar />
      
      <main style={{ minHeight: 'calc(100vh - 180px)' }}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/find-teachers" element={<FindTeachers />} />
          <Route path="/teacher/:teacherId" element={<TeacherProfile />} />
          <Route path="/become-teacher" element={<BecomeTeacher />} />
          
          {/* Protected Routes */}
          <Route 
            path="/my-lessons" 
            element={
              <ProtectedRoute>
                <MyLessons />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/messages" 
            element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/lesson/:bookingId" 
            element={
              <ProtectedRoute>
                <VideoRoom />
              </ProtectedRoute>
            } 
          />
          
          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      
      <Footer />
      
      {/* Toast Notifications */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
